import { motion } from "framer-motion";
import GiviLogo from "./GiviLogo";
import { FloatItem } from "./FloatingDecor";

export default function Footer() {
  return (
    <footer className="relative bg-[#FDFBF7] overflow-hidden" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 pt-24 pb-10 flex flex-col items-center text-center">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="font-serif italic font-light text-4xl md:text-6xl tracking-tight text-[#2C2421]"
        >
          Make Every Moment{" "}
          <span className="text-givi-gradient font-medium">Yours</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
          className="relative mt-12"
        >
          <FloatItem type="heart" filled color="#E0A3AC" className="w-4 h-4 -top-4 -right-10" delay={0.4} duration={7} drift={10} sway={6} />
          <GiviLogo className="w-40" />
        </motion.div>

        <div className="w-full mt-16 pt-8 border-t border-[#E8E1D9] flex flex-col md:flex-row items-center justify-between gap-3 text-xs tracking-[0.25em] uppercase text-[#8A7D78]">
          <span>© 2026 GIVI</span>
          <span className="text-[#C57B89]">givi.oneeight.au</span>
          <span>Coming Soon</span>
        </div>
      </div>
    </footer>
  );
}
